import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <path
        fill="white"
        stroke="#A8B1B4"
        strokeWidth="0.4"
        d="M9 9.2h.008a.835.835 0 00.282-.057h0l.012-.006 6.532-3.086h0l.003-.002a.662.662 0 00.263-.233.62.62 0 00.1-.337h0v-.013a.615.615 0 00-.115-.319.658.658 0 00-.262-.214l-6.53-3.069h0a.685.685 0 00-.58 0h-.001L2.184 4.932a.649.649 0 00-.277.226.605.605 0 000 .686c.07.1.165.178.277.226l6.528 3.068h0l.006.002A.735.735 0 009 9.2zm5.031-3.72L9.002 7.865 3.973 5.479l5.03-2.386 5.028 2.386z"
      ></path>
      <path
        fill="white"
        stroke="#A8B1B4"
        strokeWidth="0.4"
        d="M8.707 13.168l.017.008.019.005c.09.023.185.025.276.006a.613.613 0 00.273-.064l6.53-3.103s0 0 0 0a.651.651 0 00.34-.367.62.62 0 00-.032-.497.66.66 0 00-.384-.322.693.693 0 00-.503.03h0-.002L8.998 11.84 2.755 8.908h0l-.003-.001a.693.693 0 00-.5-.027.66.66 0 00-.382.321.62.62 0 00-.034.496.65.65 0 00.337.367s0 0 0 0l6.534 3.104z"
      ></path>
      <path
        fill="white"
        stroke="#A8B1B4"
        strokeWidth="0.4"
        d="M9.009 17.2h.008a.825.825 0 00.283-.058h0l.012-.005 6.52-3.1h0a.649.649 0 00.334-.37.634.634 0 00-.424-.814.68.68 0 00-.503.04l-6.227 2.96-6.213-2.967a.686.686 0 00-.753.058.646.646 0 00-.245.46.619.619 0 00.189.484c.062.062.136.11.217.143l6.514 3.106h0l.006.002c.089.04.185.06.282.061z"
      ></path>
    </svg>
  );
}

export default Icon;
